<div class="d-flex">
  @let selected = selectedPills(); @if(selected.length) {
  <div class="selected-pills">
    @for(pill of selected; track pill; let last = $last,index = $index) {
    @if(last) {
    <div
      [ngClass]="pill.customClasses ?? 'btn btn-light'"
      class="active"
      (click)="removeSelected(pill)"
    >
      {{ pill.displayName || pill.value }}
      <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
    </div>
    } @else {
    <div [ngClass]="pill.customClasses ?? 'btn btn-light'" class="active">
      {{ pill.displayName || pill.value }}
    </div>
    } }
  </div>
  } @let pills = visiblePills(); @if(pills.length) {
  <ul [ngClass]="{ 'flex-wrap': wrapItems() }">
    @for(pill of pills; track pill) {
    <li>
      <button
        [ngClass]="pill.customClasses ?? 'btn btn-light'"
        (click)="selectPill(pill)"
      >
        {{ pill.displayName || pill.value }}
      </button>
    </li>
    }
  </ul>
  }
</div>
